import { addFormwinkItems } from '@theme/formwink-cart';
import { StandardEvents } from '@shopify/events';
(() => {
  const room = document.querySelector('[data-growth-demo]');
  if (!room) return;
  const feedback = room.querySelector('[data-demo-feedback]');
  const bundle = room.querySelector('[data-demo-bundle]');
  const cards = [...room.querySelectorAll('[data-product-card]')];
  const isProductPage = room.dataset.isProductPage === 'true';
  const pairOffer = room.querySelector('[data-pair-offer]');
  const currentVariants = (() => {
    try { return JSON.parse(room.dataset.currentVariants || '[]'); } catch { return []; }
  })();
  let busy = false;
  const selected = card => card.querySelector('select').selectedOptions[0];
  const mainFormComponent = () => {
    if (!room.dataset.currentProductId) return null;
    return document.querySelector('.product-information product-form-component[data-product-id="' + room.dataset.currentProductId + '"]');
  };
  const mainProductSection = () => document.querySelector('.product-information');
  const mainForm = () => mainFormComponent()?.querySelector('form.shopify-product-form');
  const currentVariant = () => {
    const variantId = mainForm()?.querySelector('[name="id"]')?.value || room.dataset.currentVariantId;
    return currentVariants.find(variant => String(variant.id) === String(variantId));
  };
  const currentQuantity = () => Math.max(1, Number(mainForm()?.querySelector('[name="quantity"]')?.value) || 1);
  const update = () => {
    const included = cards.filter(card => card.querySelector('[data-include]').checked);
    const selectedCurrentVariant = isProductPage ? currentVariant() : null;
    const currentAvailable = !isProductPage || Boolean(selectedCurrentVariant && selectedCurrentVariant.available !== false);
    const available = included.length > 0 && currentAvailable && included.every(card => selected(card) && !selected(card).disabled);
    bundle.disabled = !available;
    const currentTotal = isProductPage ? Number(selectedCurrentVariant?.price || 0) * currentQuantity() : 0;
    const addOnTotal = included.reduce((total, card) => total + Number(selected(card).dataset.price), 0);
    room.querySelector('[data-set-price]').textContent = available
      ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:room.dataset.currency || 'USD'}).format((currentTotal + addOnTotal) / 100)
      : '';
    if (pairOffer) {
      const eligibleAddOns = included.filter(card => card.dataset.pair10Eligible === 'true').length;
      const eligibleCurrent = room.dataset.currentPair10Eligible === 'true' ? currentQuantity() : 0;
      pairOffer.hidden = eligibleAddOns + eligibleCurrent < 2;
    }
  };
  const item = card => {
    const option = selected(card);
    if (!option || option.disabled) throw new Error('Please choose an available style.');
    return {id:Number(option.value), quantity:1};
  };
  const currentItem = () => {
    const variant = currentVariant();
    if (!variant || variant.available === false) throw new Error('Please choose an available style.');
    return {id:Number(variant.id), quantity:currentQuantity()};
  };
  const add = async items => {
    if (busy) return;
    busy = true;
    const buttons = [...room.querySelectorAll('button')];
    buttons.forEach(button => {button.dataset.wasDisabled = String(button.disabled); button.disabled = true; button.setAttribute('aria-busy','true');});
    feedback.textContent = 'Adding to your cart…';
    try {await addFormwinkItems(room, items); feedback.textContent = 'Added to your cart.';}
    catch (error) {feedback.textContent = error.message || room.dataset.errorMessage;}
    finally {busy = false; buttons.forEach(button => {button.disabled = button.dataset.wasDisabled === 'true'; button.removeAttribute('aria-busy');}); update();}
  };
  room.addEventListener('change', update);
  room.addEventListener('input', update);
  document.addEventListener('change', event => {
    if (mainProductSection()?.contains(event.target)) update();
  });
  document.addEventListener('input', event => {
    if (mainProductSection()?.contains(event.target)) update();
  });
  document.addEventListener(StandardEvents.productSelect, event => {
    if (!mainProductSection()?.contains(event.target)) return;
    Promise.resolve(event.promise).then(update, update);
  });
  room.addEventListener('submit', event => {
    if (!event.target.matches('.gd-product-form')) return;
    event.preventDefault();
    try {add([item(event.target.closest('[data-product-card]'))]);} catch (error) {feedback.textContent = error.message;}
  });
  bundle.addEventListener('click', () => {
    try {
      const items = cards.filter(card => card.querySelector('[data-include]').checked).map(item);
      if (isProductPage) items.unshift(currentItem());
      add(items);
    } catch (error) {
      feedback.textContent = error.message;
    }
  });
  update();
})();
